import { ElementRef } from '@angular/core';
import { COMPANY, COMPANY_FUND, MODEL_PORTFOLIO, MUTUAL_FUND } from 'Angular/constants/core.constants';
import { DATA_EXPORT_FEATURE, LEGACY_QUOTE_PAGE_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { DIRECT_HOLDINGS, INVESTED_HOLDINGS, UNDERLYING_HOLDINGS } from 'ModelPortfolioApp/ts/shared/constants';
import { BROAD_ASSET_CLASS, CATEGORY_NAME, EQUITY_STYLE, PEER_GROUP, SECTOR, } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { HoldingsCategoriesService } from 'SecuritiesApp/ts/services/holdings-categories.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { downloadUrl } from 'Angular/utils/download';
import { getHoldingsLayerUserPreferenceKey, getSecurityTypeFromId } from 'Angular/utils/security-utils';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "SecuritiesApp/ts/services/holdings-categories.service";
import * as i3 from "AccountsApp/ts/services/accounts.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../module-upsell/module-upsell.component";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = () => ({ button: "btn btn-secondary btn-block dropdown-toggle", dropdownItem: "text-default" });
const _c1 = () => ({ button: "btn btn-block btn-secondary dropdown-toggle", dropdownMenu: "dropdown-menu-right" });
function HoldingsCategoriesTableComponent_ycn_single_select_dropdown_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 21);
    i0.ɵɵlistener("changeHandler", function HoldingsCategoriesTableComponent_ycn_single_select_dropdown_6_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateHoldingsLayer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c1))("config", ctx_r1.HOLDINGS_LAYER_DROPDOWN_CONFIG)("selectedValue", ctx_r1.selectedHoldingsLayer);
} }
function HoldingsCategoriesTableComponent_ng_container_22_td_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(field_r3);
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_ng_container_10_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 38);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r4 = ctx.$implicit;
    const category_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tooltipTitle", ctx_r1.getBenchmarkHover(category_r5.category, category_r5.benchmark.name));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", value_r4, " ");
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_ng_container_10_td_1_Template, 2, 2, "td", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const category_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r5.benchmark.values);
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "td")(1, "td")(2, "td")(3, "td");
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_tr_18_td_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", value_r6, " ");
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_tr_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 39)(2, "div", 40)(3, "a", 41);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_tr_18_td_7_Template, 2, 1, "td", 29);
    i0.ɵɵelement(8, "td");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r7 = ctx.$implicit;
    const isFirst_r8 = ctx.first;
    i0.ɵɵclassProp("tr-overlined", isFirst_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", holding_r7.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", i0.ɵɵinterpolate(holding_r7.url), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", holding_r7.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(holding_r7.weight);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", holding_r7.values);
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_td_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", value_r9, " ");
} }
function HoldingsCategoriesTableComponent_ng_container_22_tbody_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody")(1, "tr", 30)(2, "td", 25)(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "td")(6, "td")(7, "td")(8, "td")(9, "td");
    i0.ɵɵtemplate(10, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_ng_container_10_Template, 2, 1, "ng-container", 31)(11, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_ng_template_11_Template, 4, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(13, "td")(14, "td")(15, "td")(16, "td")(17, "td");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_tr_18_Template, 9, 8, "tr", 32);
    i0.ɵɵelementStart(19, "tr", 30)(20, "td", 25);
    i0.ɵɵtext(21, "Average");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "td")(23, "strong", 33);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(25, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_td_25_Template, 2, 1, "td", 29);
    i0.ɵɵelement(26, "td");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "tr", 34);
    i0.ɵɵelement(28, "td", 35);
    i0.ɵɵelementStart(29, "td", 36);
    i0.ɵɵtext(30, "\u00A0");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const category_r5 = ctx.$implicit;
    const noBenchmark_r10 = i0.ɵɵreference(12);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(category_r5.category);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", category_r5.category !== "Other" && category_r5.benchmark !== undefined)("ngIfElse", noBenchmark_r10);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngForOf", category_r5.holdings);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("Sum ", category_r5.aggregate.weight);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r5.aggregate.values);
} }
function HoldingsCategoriesTableComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 22)(2, "thead")(3, "tr");
    i0.ɵɵelement(4, "td")(5, "td");
    i0.ɵɵelementStart(6, "td", 23)(7, "strong");
    i0.ɵɵtext(8, "Key Stats");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "td", 23)(10, "strong");
    i0.ɵɵtext(11, "Performance");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "td", 23)(13, "strong");
    i0.ɵɵtext(14, "Risk (5Y)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(15, "td");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "tr", 24)(17, "td", 25);
    i0.ɵɵelement(18, "br");
    i0.ɵɵelementStart(19, "div", 26)(20, "div", 7);
    i0.ɵɵtext(21, "Benchmark");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(22, "svg", 27);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(23, "td", 28);
    i0.ɵɵtext(24, "Current ");
    i0.ɵɵelement(25, "br");
    i0.ɵɵtext(26, "Weight");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, HoldingsCategoriesTableComponent_ng_container_22_td_27_Template, 2, 1, "td", 29);
    i0.ɵɵelement(28, "td");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(29, HoldingsCategoriesTableComponent_ng_container_22_tbody_29_Template, 31, 6, "tbody", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(27);
    i0.ɵɵproperty("ngForOf", ctx_r1.holdingsCategories.fields.all);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.holdingsCategories.data);
} }
/**
 *
 * HoldingsCategoriesTableComponent.
 *
 * Required Attributes:
 *      @ displaySecurityID: shorthand display of security
 *      @ securityID: display security ID
 *      @ validCategoryTypes: jsonify list of valid category types, otherwise default to ['sector']
 */
export class HoldingsCategoriesTableComponent {
    constructor(el, featureService, holdingsCategoriesService, accountsService) {
        this.el = el;
        this.featureService = featureService;
        this.holdingsCategoriesService = holdingsCategoriesService;
        this.accountsService = accountsService;
        this.showHoldingsLayerSelection = false;
        this.labels = {
            [BROAD_ASSET_CLASS]: 'Broad Asset Class',
            [CATEGORY_NAME]: 'Fund Category',
            [EQUITY_STYLE]: 'Equity Style',
            [PEER_GROUP]: 'Peer Group',
            [SECTOR]: 'Sector',
        };
        this.dropdownConfig = {
            list: [
                {
                    type: 'option',
                    label: this.labels[BROAD_ASSET_CLASS],
                    value: BROAD_ASSET_CLASS,
                },
                {
                    type: 'option',
                    label: this.labels[PEER_GROUP],
                    value: PEER_GROUP,
                },
                {
                    type: 'option',
                    label: this.labels[EQUITY_STYLE],
                    value: EQUITY_STYLE,
                    requiredFeature: LEGACY_QUOTE_PAGE_FEATURE,
                },
                {
                    type: 'option',
                    label: this.labels[SECTOR],
                    value: SECTOR,
                },
            ],
        };
        this.HOLDINGS_LAYER_DROPDOWN_CONFIG = {
            list: [
                { value: DIRECT_HOLDINGS, label: 'Holdings' },
                { value: UNDERLYING_HOLDINGS, label: 'Underlying Holdings' },
            ],
        };
        this.selectedHoldingsLayer = DIRECT_HOLDINGS;
        this.isFundOfFunds = false;
        this.hasNestedModelPortfolios = false;
        this.loading = true;
        this.securityType = '';
        this.displaySecurityID = el.nativeElement.getAttribute('displaySecurityID');
        this.securityID = el.nativeElement.getAttribute('securityID');
        this.isFundOfFunds = el.nativeElement.getAttribute('isFundOfFunds') === 'True';
        this.hasNestedModelPortfolios = el.nativeElement.getAttribute('hasNestedModelPortfolios') === 'True';
        const validCategoryTypes = JSON.parse(el.nativeElement.getAttribute('validCategoryTypes') || [SECTOR]);
        this.dropdownConfig.list = this.dropdownConfig.list.filter((item) => validCategoryTypes.indexOf(item.value) > -1);
        let _rest;
        [this.selectedCategoryType, ..._rest] = validCategoryTypes;
        this.securityType = getSecurityTypeFromId(this.securityID);
        this.accountsService.useGenericData([LEGACY_QUOTE_PAGE_FEATURE]).subscribe((useGenericDataDisplay) => {
            if (!useGenericDataDisplay && this.featureService.userHasFeatures([LEGACY_QUOTE_PAGE_FEATURE])) {
                this.dropdownConfig = {
                    list: this.dropdownConfig.list.map((config) => {
                        if (config.value === PEER_GROUP) {
                            return {
                                type: 'option',
                                label: this.labels[CATEGORY_NAME],
                                value: CATEGORY_NAME,
                                requiredFeature: LEGACY_QUOTE_PAGE_FEATURE,
                            };
                        }
                        return config;
                    }),
                };
            }
            else {
                this.dropdownConfig = {
                    list: this.dropdownConfig.list.filter((config) => config.value !== EQUITY_STYLE),
                };
            }
        });
        this.showHoldingsLayerSelection =
            this.securityType != null &&
                [COMPANY, MUTUAL_FUND, MODEL_PORTFOLIO].includes(this.securityType) &&
                (this.hasNestedModelPortfolios || this.isFundOfFunds);
        if (this.hasNestedModelPortfolios) {
            this.HOLDINGS_LAYER_DROPDOWN_CONFIG.list.splice(1, 0, {
                value: INVESTED_HOLDINGS,
                label: 'Invested Holdings',
            });
        }
    }
    ngOnInit() {
        this.getInitialSelectedHoldingsLayer();
    }
    dropdownHandler(selectedItem) {
        this.selectedCategoryType = selectedItem;
        this.queryHoldingsCategories();
    }
    queryHoldingsCategories() {
        this.holdingsCategoriesService
            .getHoldingsCategories(this.securityID, this.selectedCategoryType, this.selectedHoldingsLayer)
            .subscribe((holdingsCategories) => {
            this.holdingsCategories = holdingsCategories;
        });
    }
    getBenchmarkHover(category, securityName) {
        if (this.selectedCategoryType === CATEGORY_NAME) {
            return `${category} Benchmark: Average Return of Category`;
        }
        return `${category} Benchmark: ${securityName}`;
    }
    get selectedCategoryLabel() {
        // This casting is needed because objects can't be indexed by CategoryType nor string
        return this.labels[this.selectedCategoryType];
    }
    get footer() {
        if (typeof this.holdingsCategories === 'undefined')
            return '';
        return `Performance as of ${this.holdingsCategories.meta.latest_performance_date}. Returns for periods of 1 year and above are annualized. Risk metrics as of ${this.holdingsCategories.meta.latest_risk_date}. Other metrics vary.`;
    }
    exportHoldingDataUrl() {
        if (!this.featureService.userHasFeatures([DATA_EXPORT_FEATURE])) {
            this.featureNeededComponent.openModal(DATA_EXPORT_FEATURE);
            return;
        }
        const url = `/pdf_reports/holdings_categorize/${this.securityID}/${this.selectedCategoryType}?holdings_layer=${this.selectedHoldingsLayer}`;
        downloadUrl(url);
    }
    updateHoldingsLayer(layerSelection) {
        this.selectedHoldingsLayer = layerSelection;
        this.queryHoldingsCategories();
        const userPreferenceKey = getHoldingsLayerUserPreferenceKey(this.securityType);
        if (userPreferenceKey) {
            this.accountsService.putUserPreferencesAndRefreshCache({ [userPreferenceKey]: this.selectedHoldingsLayer });
        }
    }
    getDefaultSelectedHoldingsLayer(userPreferences) {
        const securityHoldingsLayerSelectionMap = {
            [COMPANY]: userPreferences.company_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [COMPANY_FUND]: userPreferences.company_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [MODEL_PORTFOLIO]: userPreferences.model_portfolio_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [MUTUAL_FUND]: userPreferences.mutual_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
        };
        const holdingsLayer = securityHoldingsLayerSelectionMap[this.securityType] ?? DIRECT_HOLDINGS;
        if (!this.HOLDINGS_LAYER_DROPDOWN_CONFIG.list.map((option) => option.value).includes(holdingsLayer)) {
            return DIRECT_HOLDINGS;
        }
        return holdingsLayer;
    }
    getInitialSelectedHoldingsLayer() {
        if (!this.showHoldingsLayerSelection) {
            this.selectedHoldingsLayer = DIRECT_HOLDINGS;
            this.queryHoldingsCategories();
            this.loading = false;
        }
        else {
            this.accountsService.getUserPreferences().subscribe((preference) => {
                this.selectedHoldingsLayer = this.getDefaultSelectedHoldingsLayer(preference);
                this.queryHoldingsCategories();
                this.loading = false;
            });
        }
    }
}
HoldingsCategoriesTableComponent.ɵfac = function HoldingsCategoriesTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsCategoriesTableComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.HoldingsCategoriesService), i0.ɵɵdirectiveInject(i3.AccountsService)); };
HoldingsCategoriesTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsCategoriesTableComponent, selectors: [["ycn-holdings-categories-table"]], viewQuery: function HoldingsCategoriesTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, standalone: false, decls: 26, vars: 10, consts: [["noBenchmark", ""], [1, "page-header"], [1, "page-title"], [1, "page-name"], [1, "form-inline", "ml-auto"], [1, "col-auto", "page-header-actions"], [3, "customCssClasses", "config", "selectedValue", "changeHandler", 4, "ngIf"], [1, "form-label", "form-label-thin"], [3, "changeHandler", "config", "customCssClasses", "selectedValue"], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [1, "btn", "btn-secondary", 3, "click"], [1, "panel-content", 2, "min-height", "200px"], [3, "title"], [1, "company-financials-table-wrap", 2, "margin-right", "0px"], [1, "company-financials-table", 2, "margin-left", "190px"], [4, "ngIf"], [1, "panel-date"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "table", "table-dense", "text-right"], ["colspan", "4", 1, "text-center", "cell-group-header"], [1, "tr-no-border"], [1, "table-dynamic-name-middle", "text-left"], [1, "table-label"], ["ycnIcon", "", "name", "icon-square", "role", "img", 1, "text-purple-extralight"], ["rowspan", "2"], [4, "ngFor", "ngForOf"], [1, "tr-overlined"], [4, "ngIf", "ngIfElse"], [3, "tr-overlined", 4, "ngFor", "ngForOf"], [1, "text-nowrap"], [1, "tr-spacer"], [1, "table-dynamic-name-middle"], ["colspan", "99"], ["class", "is-highlighted", "ycnTooltip", "", "tooltipPlacement", "bottom", 3, "tooltipTitle", 4, "ngFor", "ngForOf"], ["ycnTooltip", "", "tooltipPlacement", "bottom", 1, "is-highlighted", 3, "tooltipTitle"], ["ycnTooltip", "", "tooltipPlacement", "bottom", 1, "table-dynamic-name-middle", "text-left", 3, "tooltipTitle"], [1, "td-ellipsis"], [1, "td-ellipsis-content", "width-200", 3, "href"]], template: function HoldingsCategoriesTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵtemplate(6, HoldingsCategoriesTableComponent_ycn_single_select_dropdown_6_Template, 1, 4, "ycn-single-select-dropdown", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵtext(8, "Group Holdings by:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "ycn-single-select-dropdown", 8);
        i0.ɵɵlistener("changeHandler", function HoldingsCategoriesTableComponent_Template_ycn_single_select_dropdown_changeHandler_9_listener($event) { return ctx.dropdownHandler($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(10, "div", 9)(11, "div", 10)(12, "h3", 11);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 12)(15, "div", 13)(16, "a", 14);
        i0.ɵɵlistener("click", function HoldingsCategoriesTableComponent_Template_a_click_16_listener() { return ctx.exportHoldingDataUrl(); });
        i0.ɵɵtext(17, " Export ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(18, "div", 15);
        i0.ɵɵelement(19, "ycn-module-upsell", 16);
        i0.ɵɵelementStart(20, "div", 17)(21, "div", 18);
        i0.ɵɵtemplate(22, HoldingsCategoriesTableComponent_ng_container_22_Template, 30, 2, "ng-container", 19);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 20);
        i0.ɵɵtext(24);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(25, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.displaySecurityID, " Holdings By Category");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showHoldingsLayerSelection);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("config", ctx.dropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(9, _c0))("selectedValue", ctx.selectedCategoryType);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("Holdings Analysis - ", ctx.selectedCategoryLabel);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("title", "Holdings Analysis - " + ctx.selectedCategoryLabel);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.holdingsCategories !== undefined);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.footer);
    } }, dependencies: [i4.NgForOf, i4.NgIf, i5.FeatureNeededComponent, i6.IconDirective, i7.ModuleUpsellComponent, i8.SingleSelectDropdownComponent, i9.TooltipDirective], encapsulation: 2 });
